import { ReactNode } from "react";

export type IAdditionalSignInStrategy = null | (() => ReactNode);
export const AdditionalSignInStrategy: IAdditionalSignInStrategy = null
